(function () {
  if (window.alwanOptionLabelsLoaded) return;
  window.alwanOptionLabelsLoaded = true;
  const translations = document.currentScript.dataset;
  const observed = new WeakSet();

  function format(value) {
    return value.replace(/(\d(?:[.,]\d+)?)\s*(mm|cm|m)\b/gi, (match, number, unit) => {
      const key = {m: 'meter', cm: 'centimeter', mm: 'millimeter'}[unit.toLowerCase()];
      return number.replace(/[.,]0+$/, '') + ' ' + translations[key];
    }).replace(/\u200e/g, '').replace(/(\d\s*(?:م|سم|ملم)?)\s*[xX×]\s*(?=\d)/g, '$1 × ');
  }

  // Sizes read in Arabic order: number before unit, first dimension on the
  // right («2.5 م × 2.75 م»). The label stays RTL and is isolated from the
  // text around it; forcing LTR put «م» before each number.
  function setReadingOrder(label, text) {
    if (!(/\d/.test(text) && /×/.test(text))) return;
    label.setAttribute('dir', 'rtl');
    label.style.direction = 'rtl';
    label.style.unicodeBidi = 'isolate';
  }

  function update(scope) {
    scope.querySelectorAll('[data-alwan-size-text]').forEach(label => {
      const text = format(label.textContent.trim());
      if (label.textContent !== text) label.textContent = text;
      setReadingOrder(label, text);
    });
    scope.querySelectorAll('.product-form__input').forEach(field => {
      const input = field.querySelector('input[type="radio"], select');
      if (!input) return;
      const name = input.name.replace(/^options\[|\]$/g, '').replace(/^edit-cart-/, '').trim().toLowerCase();
      const isColor = ['color', 'colour', 'colors', 'colours', 'اللون', 'الألوان', 'الالوان'].includes(name);
      const isSize = ['size', 'sizes', 'dimension', 'dimensions', 'المقاس', 'المقاسات', 'الحجم', 'الأبعاد', 'الابعاد'].includes(name);
      if (!isColor && !isSize) return;
      const heading = field.querySelector('.form__label');
      if (heading) {
        Array.from(heading.childNodes).filter(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()).forEach(node => {
          const title = (isColor ? translations.colorLabel : translations.sizeLabel) + ': ';
          if (node.textContent !== title) node.textContent = title;
        });
      }
      if (isColor) return;
      field.querySelectorAll('.product-form__label .text, option, [data-header-option]').forEach(label => {
        const text = format(label.textContent.trim());
        if (label.textContent !== text) label.textContent = text;
        setReadingOrder(label, text);
      });
    });
  }

  function initialize() {
    document.querySelectorAll('main, #halo-cart-sidebar, #halo-edit-cart-popup, #halo-quick-view-popup, .productView-options').forEach(scope => {
      if (scope.matches('.productView-options') && scope.closest('main')) return;
      update(scope);
      if (observed.has(scope)) return;
      observed.add(scope);
      new MutationObserver(() => update(scope)).observe(scope, {childList: true, subtree: true, characterData: true});
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
